import PropTypes from 'prop-types';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { exitActivityToWorkshop } from 'a/hub/actions/workshopActions';
import {
  openChallengeQuestSuccessModal,
  openChallengeQuestModal,
} from 'a/hub/actions/modalSystemActions';
import {
  getSkillGamesProgressRatio,
  getSkillGamesProgressText,
  getChallengeQuestProgressRatio,
  getChallengeQuestProgressText,
} from 'a/hub/selectors/studentProgressSelectors';
import {
  getIsChallengeQuestComplete,
  getIsChallengeQuest,
} from 'a/hub/selectors/workshopSelectors';
import {
  FractionText,
  BatteryIcon,
  SuccessPanel,
  DescriptionText,
  HeaderText,
} from '../sharedComponents';

const GameSuccessModal = ({ config, closeModal }) => {
  const dispatch = useDispatch();
  const isChallengeQuest = useSelector(getIsChallengeQuest);
  const isChallengeQuestComplete = useSelector(getIsChallengeQuestComplete);

  const completeRatio = useSelector(isChallengeQuest ? getChallengeQuestProgressRatio : getSkillGamesProgressRatio);
  const fractionText = useSelector(isChallengeQuest ? getChallengeQuestProgressText : getSkillGamesProgressText);

  const { heading = 'Charging Power...' } = config;
  const text = config.text && !isChallengeQuest ? config.text : '*Skill Game* complete!';

  const onConfirmPress = (e) => {
    if (isChallengeQuest) {
      if (isChallengeQuestComplete) {
        dispatch(openChallengeQuestSuccessModal());
      } else {
        dispatch(openChallengeQuestModal());
      }
    }
    dispatch(exitActivityToWorkshop(config));
    closeModal(e);
  };

  return (
    <SuccessPanel onConfirm={onConfirmPress} actionScope="game-success-modal">
      <StyledContainer>
        <HeaderText style={{ width: 'inherit' }}>{heading}</HeaderText>
        <DescriptionText width={210}>{text}</DescriptionText>
      </StyledContainer>
      <BatteryIcon top={225} left={323} completeRatio={completeRatio} />
      <FractionText top={308}>{fractionText}</FractionText>
    </SuccessPanel>
  );
};

GameSuccessModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default GameSuccessModal;

const StyledContainer = styled.div`
  position: absolute;
  top: 177px;
  left: 500px;
  width: 210px;
  height: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
